import {atom} from "recoil";
export const matriculasTodasState = atom({
  key: 'matriculasTodasState',
  default: null,
  effects: [
    // Nunca em hipótese alguma adicione o efeito de persistir isso no storage, afeta a contratação
  ]
});